import Environment from 'helpers/environment'
import Brand from 'helpers/brand'
import { DealerPlan, Session } from 'types/Session'

class Apptentive {
  static createConversation (session: Session) {
    window.ApptentiveSDK?.createConversation?.({
      person: {
        unique_token: session.userId,
        custom_data: {
          dealer_id: session.dealerId,
          email: session.dealerEmail,
          zip_code: session.zip,
          state: session.state,
          device_count: session.deviceCount,
          tier: Apptentive._getTier(session.dealerPlan),
          plan: Apptentive._getPlan(session.dealerPlan)
        }
      }
    })
  }

  static updatePerson (dealerPlan: Partial<DealerPlan> | null) {
    window.ApptentiveSDK?.updatePerson?.({
      custom_data: {
        tier: Apptentive._getTier(dealerPlan),
        plan: Apptentive._getPlan(dealerPlan)
      }
    })
  }

  static getApptentiveAccountId () {
    if (Environment.isProduction()) {
      return Brand.isASAirHome() ? '641e0e0ce2741f0adc000006' : '641e0f78e2741f0b5e000011'
    } else {
      return Brand.isASAirHome() ? '641e0c4fcd76674908000002' : '63f66aa74acadb107900000f'
    }
  }

  static _getTier (dealerPlan: Partial<DealerPlan> | null) {
    if (dealerPlan?.in_trial === true) {
      return 'trial'
    } else if (dealerPlan?.tier === 'premium') {
      return 'premium'
    } else {
      return 'standard'
    }
  }

  static _getPlan (dealerPlan: Partial<DealerPlan> | null) {
    if (dealerPlan?.plan?.includes('monthly')) {
      return 'monthly'
    } else if (dealerPlan?.plan?.includes('yearly')) {
      return 'yearly'
    } else {
      return 'none'
    }
  }

  static sendEvent (eventName: string) {
    window.ApptentiveSDK?.engage?.(eventName)
  }
}

export default Apptentive
